import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const levelsSlice = createSlice({
    name: 'levels',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateLevel: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setLevels: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setLevel: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setLevelMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setLevelError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getLevelsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/levels`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setLevels(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setLevelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getLevelThunk = (level_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/levels/${level_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setLevel(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setLevelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createLevelThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/levels/createLevel`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setLevelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setLevelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateLevelThunk = (level_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/levels/updateLevel/${level_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setLevelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setLevelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteLevelThunk = (level_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/levels/${level_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setLevelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setLevelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateLevel,
    setLevels,
    setLevel,
    setLevelMessages,
    setLevelError
} = levelsSlice.actions;

export default levelsSlice.reducer;